module.exports = __webpack_public_path__ + "static/img/Dougal_Howard_desktop.de5115a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dougal_Howard_desktop.jpg
// module id = QLLn
// module chunks = 0